import { Small } from "@/components/standard/BFText"
import { Horizontal } from "@/components/standard/BFLayout"
import ArchiveIcon from "@/assets/icons/archive-icon.svg"
import { useArchiveLoanMutation } from "@/queries/loan-dashboard"
import { BFPressable } from "@/components/buttons/CommonButtons"
import { cn } from "@/components/util/cn"
import { loanAppDashboardPath } from "@/screens/loans/utils/LoanUtils"
import { router } from "expo-router"
import { BFColors } from "@/constants/Colors"
import { hideToast, showSuccessToast } from "@/components/toasts/AppToast"

export const LoanArchiveAction = ({ loanId }: { loanId: string }) => {
  const archiveLoanMutation = useArchiveLoanMutation()

  return (
    <Horizontal className={"justify-center items-center gap-[3px]"}>
      <BFPressable
        testID="dashboard-loan-archive-button"
        title="Loan Dashboard Archive"
        className="flex flex-row items-center justify-center"
        loading={archiveLoanMutation.isPending}
        onPress={() => {
          archiveLoanMutation.mutate(
            { loanId },
            {
              onSuccess(resp) {
                const redirectId = resp.deleteLoanApplication?.redirectLoanId

                showSuccessToast({
                  title: `Quote Archived`,
                  message:
                    "View 'Other Loans' to locate and restore the inquiry",
                  autoHide: false,
                  visibilityTime: 5000,
                  onPress: () => {
                    hideToast()
                  },
                })

                if (redirectId) {
                  router.dismissTo(loanAppDashboardPath(redirectId))
                } else {
                  router.dismissTo("/loans")
                }
              },
            }
          )
        }}
      >
        {({ pressed, loading }) => {
          return (
            <Horizontal
              className={cn(
                "justify-center items-center self-stretch gap-[3px]",
                (pressed || loading) && "opacity-50"
              )}
            >
              <Small className={"text-calm-blue underline"}>Archive</Small>
              <ArchiveIcon width={12} height={12} color={BFColors.calmBlue} />
            </Horizontal>
          )
        }}
      </BFPressable>
    </Horizontal>
  )
}
